import React from 'react';
import { Config } from "../../Config";

export default function Footer() {
  const now = new Date();
  const currentYear = now.getFullYear();

  return (
    <div className="docpro_copyright">© {currentYear} { Config.appName}. All rights reserved. <span className='docpro_secondary_color'>{Config.appVersion }</span></div>
  );
}
